import { Component } from '@angular/core';
import {ThemeService}from '../app/theme.service'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'scholerx';
  constructor(private themeService: ThemeService) {}

  get isDarkMode(): boolean {
    return this.themeService.getCurrentTheme()
  }
}
